import React from 'react';
import styled from 'styled-components';
import SpanPckgNavPrice from '../common/price/SpanPckgNavPrice';
import ApplyPckgProdImg from '../common/image/ApplyPckgProdImg';
import CountInputBtn from '../common/button/CountInputBtn';
import { useDispatch } from 'react-redux';
import { setEsApplyProdEditAction, setEsApplyProdDelAction } from '../../modules/es/esApplyModule';


const EsApplyPckgProdBlock = styled.div``;

const EsApplyPckgProdLiBlock = styled.li`
    float: left;
    width: 25%;
    padding-left: 37px;
    padding-top: 10px;

    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;

const EsApplyPckgProdTitleBlock = styled.div`
    line-height: 1.5;
    width: 265px;
    padding-left: 120px;
    color: #333;
    font-size: 14px;
`;


const EsApplyPckgProd = ({ prodinfo }) => {
    // console.log("-----> prodinfo : " + JSON.stringify(prodinfo));

    const dispatch = useDispatch();

    const changeValueHandler = (num) => {
        // console.log("changeValueHandler ++++ " + num);
        // console.log("prodinfo ++++ " + JSON.stringify(prodinfo));
        // 전체 개수 업데이트 
        prodinfo.qty = num;
        dispatch(setEsApplyProdEditAction(prodinfo));
    }

    const handleDelClick = () => {
        dispatch(setEsApplyProdDelAction(prodinfo));
    }

    return (
        <EsApplyPckgProdBlock>
            <EsApplyPckgProdLiBlock>
                <div className="f-left">
                    <ApplyPckgProdImg img={prodinfo.img}
                        id={prodinfo.prdct_id}
                        onDelClick={handleDelClick} />
                    <CountInputBtn
                        changeValueHandler={changeValueHandler}
                        num={prodinfo.qty}
                        width="33px" height="30px" />
                </div>
                <EsApplyPckgProdTitleBlock>
                    <p style={{ fontWeight: '500', marginBottom: '20px' }}>
                        {prodinfo.prdct_nm}
                    </p>
                    <p>
                        옵션 : <span>{prodinfo.opt_nm}</span>
                    </p>
                    <div>
                        판매가 : <SpanPckgNavPrice
                            value={prodinfo.es_opt_pirce}
                            fontSize='14px' fontWeight='normal' float='none' />
                    </div>
                </EsApplyPckgProdTitleBlock>

            </EsApplyPckgProdLiBlock>
        </EsApplyPckgProdBlock>
    );
};

export default EsApplyPckgProd;